import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 712px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const TextAreaWrap = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  textarea {
    width: 100%;
    outline: none;
    border-radius: 12px;
    height: 180px;
    padding: 12px;
  }
  > span {
    position: absolute;
    color: red;
    bottom: -16px;
    font-size: 12px;
  }
  .input-wrapper {
    margin: 0;
  }
`;
